export default __webpack_public_path__ + "static/media/001-new-product.7e3a4055.svg";